import { Component, Input, OnInit } from "@angular/core";
import { serviceStatus } from "../../../core/utils/tab.util";
import { Router } from "@angular/router";
import { SingleServiceDetailsService } from "src/app/core/services/single-service-details.service";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { CallerActionsComponent } from "../caller-actions/caller-actions.component";
import {
  getDateDifferenceInDays,
  getDelayStatusColor,
  getDelayStatusText,
} from "src/app/core/utils/date.util";

@Component({
  selector: "app-tab-content",
  templateUrl: "./tab-content.component.html",
})
export class TabContentComponent {
  @Input() items: any[] = [];
  @Input() loading: boolean = true;
  @Input() currentStatus!: { label: string; value: string };

  constructor(
    private router: Router,
    private bottomSheet: MatBottomSheet,
    private singleService: SingleServiceDetailsService
  ) {}
  serviceStatus = serviceStatus;

  viewDetails(item: any) {
    this.singleService.singleServiceDetails.next(item);
    this.router.navigate(["/services/preview"], { state: { data: item } });
  }
  openDialer(phoneNumber: string) {
    window.location.href = `tel:${phoneNumber}`;
  }
  mobileAction(number: string) {
    this.bottomSheet.open(CallerActionsComponent, {
      data: {
        phone: number,
      },
      panelClass: "call-bottom-sheet",
    });
  }

  getDateDifference(createdAt: string | Date): number {
    return getDateDifferenceInDays(createdAt);
  }

  getDelayColor(createdAt: string | Date): string {
    return getDelayStatusColor(createdAt);
  }

  getDelayText(createdAt: string | Date): string {
    return getDelayStatusText(createdAt);
  }
}
